module.exports = __webpack_public_path__ + "static/img/homeTops.071e8f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeTops.png
// module id = sZtC
// module chunks = 4